<p>
  <ngb-alert *ngIf="response && response.status === 400 && response.error && response.error.errors"
             [dismissible]="false" class="mt-5 mb-4" type="error">
      <span *ngFor="let error of response.error.errors">
        <em class="ds-icon--close-outline"></em>
        {{error.message}}
        <br>
      </span>
  </ngb-alert>
  <ngb-alert *ngIf="response && response.status > 400" [dismissible]="false" class="mt-5 mb-4" type="error">
    <em class="ds-icon--close-outline"></em>
    {{'leadForm.errors.internalServerError' | cxTranslate}}
    <a (click)="openContactSupport()" class="focusable focusable__element ds-cursor--pointer">
      {{'leadForm.errors.contactSupport' | cxTranslate}}
    </a>
    {{'common.dot' | cxTranslate}}
  </ngb-alert>
</p>
